export const mutations = {
  setUser(state, payload) {
    state.user = payload
  },
  setUserData(state, payload) {
    state.userData = payload
  },
  setMemberData(state, payload) {
    state.member = payload
  },
  setUid(state, payload) {
    state.uid = payload
  },
  setRegisId(state, payload) {
    state.regisId = payload
  },
  setEmail(state, payload) {
    state.email = payload
  },
  setError(state, payload) {
    state.error = payload
  },
  setLoading(state, payload) {
    state.loading = payload
  },
  setSuccess(state, payload) {
    state.success = payload
  },
  setLayout(state, payload) {
    state.layout = payload
  },
  setInsureCompany(state, payload) {
    state.insureCompany = payload
  },
  setAgents(state, payload) {
    state.agents = payload
  },
  setUpdateAgent(state, payload) {
    const rs = state.agents.find(o => o.id === payload.id)
    if (rs) {
      const index = state.agents.indexOf(rs)
      state.agents[index] = payload
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js